import { render, staticRenderFns } from "./top-clubs.vue?vue&type=template&id=ddb235c4&"
import script from "./top-clubs.vue?vue&type=script&lang=js&"
export * from "./top-clubs.vue?vue&type=script&lang=js&"
import style0 from "./top-clubs.vue?vue&type=style&index=0&id=ddb235c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports